/**
 * Local hotel list filtering for name search (typing) vs submitted server results.
 * Mirrors iOS HotelCatalogSearch.
 */

import type { HotelSearchOffer } from '../services/hotelsApi';

/** Case-insensitive match on hotel name and formatted address. */
export function filterHotelsLocally(
  hotels: HotelSearchOffer[],
  query: string
): HotelSearchOffer[] {
  const trimmed = query.trim();
  if (!trimmed) return hotels;

  const needle = trimmed.toLowerCase();
  return hotels.filter((hotel) => {
    if (hotel.name.toLowerCase().includes(needle)) return true;
    if (hotel.formattedAddress?.toLowerCase().includes(needle)) return true;
    return false;
  });
}

/**
 * Empty query → last loaded list.
 * Query matches last submitted name search → server results as-is.
 * Otherwise → local filter of the last loaded list.
 */
export function visibleHotels(options: {
  loaded: HotelSearchOffer[];
  query: string;
  submittedQuery: string | null | undefined;
}): HotelSearchOffer[] {
  const trimmed = options.query.trim();
  if (!trimmed) return options.loaded;

  const submitted = options.submittedQuery?.trim() ?? '';
  if (submitted && submitted.toLowerCase() === trimmed.toLowerCase()) {
    return options.loaded;
  }

  return filterHotelsLocally(options.loaded, trimmed);
}
